import { RootState } from 'bootstrap';
import { useSelector } from 'react-redux';

export const getIsTrial = (state: RootState): boolean => state.app.user?.userStatus?.isTrial;

export const getIsRegistered = (state: RootState): boolean => state.app.user?.userStatus?.isRegistered;

export const getProductRequests = (state: RootState): string[] => state.app.user?.productRequests;

export const getIsTrialExpired = (state: RootState): boolean =>
  Boolean(state.app.user?.userStatus?.trialDaysLeft === 0).valueOf();

export const getTrialDaysLeft = (state: RootState): number => state.app.user?.userStatus?.trialDaysLeft;

export const getIsTrialExtensionRequested = (state: RootState): boolean => state.app.user?.trialExtensionRequested;

export const getTrialState = () => {
  const state = useSelector((state: RootState) => state);
  return {
    isTrial: getIsTrial(state),
    isExpired: getIsTrialExpired(state),
    trialDaysLeft: getTrialDaysLeft(state),
    isRegistered: getIsRegistered(state),
    isTrialExtensionRequested: getIsTrialExtensionRequested(state),
  };
};
